import React from 'react';
import ReactDOM from 'react-dom/client';
import CardFileComponent from './components/CardFileComponent/CardFileComponent';
import { CardFileProps, CardType } from "./types/types";
import { ViewType } from "./consts/viewType";
import { clearEventHandlers } from "./utils/eventRegistry";
import {arrayMove} from "@dnd-kit/sortable";
import type {UniqueIdentifier} from "@dnd-kit/core/dist/types";

class CardFile {
    private root: ReactDOM.Root | null = null;
    private container: HTMLElement;
    private props: CardFileProps;
    private sortedData: CardType[];
    private element: React.FunctionComponentElement<CardFileProps> | null = null;

    constructor(selector: string, props: CardFileProps) {
        this.container = document.getElementById(selector) as HTMLElement;

        // Если контейнер не найден, создаем его
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.id = selector;
            document.body.appendChild(this.container);
        }
        this.props = props;
        this.sortedData = props.data;
        this.render();
    }

    public switchView = (viewType: ViewType) => {
        if (!this.root) return;

        this.props = {
            ...this.props,
            config: {
                ...this.props.config,
                viewType,
            }
        };
        this.render();
    }

    public search = (vInputText: string) => {
        if (!this.root) return;

        this.props = {
            ...this.props,
            config: {
                ...this.props.config,
                searchInput: vInputText,
            }
        };
        this.render();
    }

    public addCard = (vCard: CardType) => {
        if (!this.root) return;

        this.sortedData = [
            ...this.sortedData,
            vCard
        ];

        this.render();
    }

    public updateCard = (vCard: CardType) => {
        if (!this.root) return;

        let isExistingCard = false;
        this.sortedData = this.sortedData.map(card => {
            if (card.id === vCard.id) {
                isExistingCard = true;
                return vCard;
            } else {
                return card;
            }
        });
        if (!isExistingCard) {
            this.sortedData.push(vCard);
        }

        this.render();
    }

    public deleteCard = (vCardId: number | string) => {
        if (!this.root) return;

        this.sortedData = this.sortedData.filter(card => card.id !== vCardId);
        if (this.sortedData.length === this.props.data.length) return;

        this.render();
    }

    public updateSortedData = (activeId :UniqueIdentifier, overId :UniqueIdentifier) => {
        const oldIndex = this.sortedData.findIndex((item) => item.id === activeId);
        const newIndex = this.sortedData.findIndex((item) => item.id === overId);
        this.sortedData = arrayMove(this.sortedData, oldIndex, newIndex);
        //this.render();
    }

    public destructor() {
        // Удаляем рендер компонента из DOM
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }

        // Очищаем содержимое контейнера, если нужно
        if (this.container) {
            this.container.innerHTML = '';
        }

        // Дополнительные операции по очистке, если есть (например, удаление слушателей событий)
        clearEventHandlers();
    }

    render() {
        this.element = React.createElement(CardFileComponent, {
            ...this.props,
            data: this.sortedData,
            updateSortedData: this.updateSortedData // Добавляем функцию обратного вызова
        });

        if (!this.root) {
            this.root = ReactDOM.createRoot(this.container);
        }

        this.root.render(this.element);
    }
}

export default CardFile;
